export const fieldNameFirstName = 'firstName';
export const fieldNameLastName = 'lastName';
export const fieldNamePassword = 'password';
export const fieldNamePhone = 'phone';
export const fieldNameTypeOfBusiness = 'typeOfBusiness';
export const fieldNamePartnerStatus = 'partnerStatus';
export const fieldNameNumberOfClients = 'numberOfClients';
export const fieldNameProductInterest = 'productInterest';
export const fieldNameNumberOfEntities = 'numberOfEntities';
export const fieldNameUseCase = 'useCase';
export const fieldNamePartnerSegment = 'partnerSegment';
export const fieldNameBusinessSegment = 'businessSegment';
export const fieldNameConsentMarketingAccepted = 'consentMarketingAccepted';
